import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'sum',
    pure: false
})
export class SumPipe implements PipeTransform {

    transform(value: any[] | {[key: string]: any}, property?: string | string[]): number {
        // Handle key-value pairs (objects)
        if (value && typeof value === 'object' && !Array.isArray(value)) {
            return Object.values(value).reduce((sum: number, val: any) => sum + (Number(val) || 0), 0);
        }

        // Handle arrays
        if (Array.isArray(value)) {
            if (!property) {
                // Sum array of numbers directly
                return value.reduce((sum: number, val: any) => sum + (Number(val) || 0), 0);
            }

            // Sum specific property/properties from array of objects
            return value.reduce((a: number, b: any) => {
                return a + (Array.isArray(property) ?
                    property.map(prop => +(b[prop] ?? 0)).reduce((c, d) => c + d) :
                    +(b[property] ?? 0));
            }, 0);
        }

        return 0;
    }

}
